<template>
  <page-content title="Detail" :back-button="true" :with-margin="false">
    <br />
    <template v-if="!pageLoading">
      <simple-list
        label="Tanggal Kunjungan Pertama"
        :text="formatDateForHuman(patient.first_visit_date)"
      />
      <simple-list label="No. KTP" :text="patient.id_card_number" />
      <simple-list label="Nama Lengkap" :text="patient.fullname" />
      <simple-list
        label="Tanggal Lahir"
        :text="formatDateForHuman(patient.date_of_birth)"
      />
      <simple-list
        label="Jenis Kelamin"
        :text="patient.gender == 'M' ? 'Pria' : 'Wanita'"
      />
      <simple-list label="Agama" :text="patient.religion" />
      <simple-list label="Alamat" :text="patient.address" />
      <simple-list label="Pendidikan" :text="education" />
      <simple-list label="Pekerjaan" :text="patient.profession" />
      <simple-list
        label="Status Perkawinan"
        :text="patient.marital_status == '0' ? 'Tidak Menikah' : 'Menikah'"
      />
      <simple-list label="Golongan Darah" :text="patient.blood_type" />
      <simple-list label="Departemen" :text="patient.department?.name" />
      <simple-list label="E-mail" :text="patient.email" />
      <simple-list label="Nomor HP (WhatsApp)" :text="patient.phone" />
      <br />
      <p class="mx-3 d-flex gap-2">
        <button
          class="btn btn-block btn-success"
          @click="openPatientUpdate(parseInt(patient.id))"
        >
          Ubah
        </button>
        <button
          v-if="can('manage-user-access')"
          class="btn btn-block btn-primary"
          @click="openChangeUserAccess(parseInt(patient.id))"
        >
          Atur Akses
        </button>
      </p>
      <p class="ml-3 mr-3 mt-3" v-if="can('reset-user-password')">
        <a @click="openResetPasswordConfirmBottomSheet" class="btn-reset-pwd">
          Reset password
        </a>
      </p>
    </template>
    <!-- Reset password confirmation -->
    <bottom-sheet
      :show.sync="resetPasswordDialog"
      :on-close="closeResetPasswordConfirmBottomSheet"
    >
      <span slot="title">Konfirmasi</span>
      <div slot="content">
        <p class="reset-pwd-title">Anda yakin melakukan reset password?</p>
        <small>Password default: 123456</small>
        <div class="btn-reset-pwd-wrap">
          <button
            class="btn-cancel"
            @click="closeResetPasswordConfirmBottomSheet"
          >
            Batal
          </button>
          <button
            class="btn-accept"
            @click="resetPassword(parseInt(patient.id))"
          >
            Lanjutkan
          </button>
        </div>
      </div>
    </bottom-sheet>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "patient-detail",
  data: function () {
    return {
      resetPasswordDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      pageLoading: "pageLoading",
      patient: "currentUser",
    }),
    education: function () {
      return this.educationList.find((e) => e.value == this.patient?.education)
        ?.text;
    },
  },
  methods: {
    openResetPasswordConfirmBottomSheet: function () {
      this.resetPasswordDialog = true;
    },
    closeResetPasswordConfirmBottomSheet: function () {
      this.resetPasswordDialog = false;
    },
    openPatientUpdate: function (id) {
      this.$router.push({
        name: "patient-update",
        params: { id },
      });
    },
    openChangeUserAccess: function (id) {
      this.$router.push({
        name: "change-user-access",
        params: { id },
      });
    },
    resetPassword: function (user_id) {
      this.closeResetPasswordConfirmBottomSheet();
      this.$store.dispatch("startPageLoading");
      this.$store
        .dispatch("resetPassword", user_id)
        .then(() => {
          this.$store.dispatch("stopPageLoading");
          this.$toasted.success("Password berhasil direset.");
        })
        .catch(() => {
          this.$store.dispatch("stopPageLoading");
          this.$toasted.error("Gagal! Tidak dapat menyimpan.");
        });
    },
  },
  created: function () {
    const id = this.$route.params.id;
    this.$store.dispatch("startPageLoading");
    this.$store
      .dispatch("getUser", id)
      .then(() => {
        this.$store.dispatch("stopPageLoading");
      })
      .catch(() => {
        this.$store.dispatch("stopPageLoading");
        this.$toasted.error("Gagal! Data tidak ditemukan.");
      });
  },
};
</script>
